module.exports = __webpack_public_path__ + "img/zm_fukuan@3x.bde44701.png";